import { Link } from "react-router-dom";
import { useAdmin } from "../../../contexts/AdminContext";

export default function PrizesSection() {
  const { settings } = useAdmin();
  const prizes = settings.prizes;

  return (
    <section id="prizes" className="py-24 bg-white relative overflow-hidden">
      {/* Visual background decor */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-orange-100/30 blur-[100px] rounded-full -ml-32 -mt-32" />
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="mb-20">
          <div className="flex items-center gap-2 mb-4">
            <span className="h-px w-8 bg-sky-500"></span>
            <span className="uppercase text-sky-500 text-[10px] font-black tracking-[0.2em]">
              PRESTIGE-PREISE
            </span>
          </div>
          <h2 className="font-playfair text-4xl md:text-6xl font-black text-slate-900 mt-2 leading-[1.1]">
             Über {settings.lotteryValue}<br />
            <span className="italic font-medium text-slate-400">an Preisen zu gewinnen</span>
          </h2>
        </div>

        {/* Masonry-style Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Main Prize - Span 2 rows */}
          <Link 
            to="/bien"
            className="md:col-span-2 lg:col-span-1 lg:row-span-2 group relative rounded-[2.5rem] overflow-hidden shadow-2xl transition-all duration-700 hover:-translate-y-2 border-4 border-white block"
          >
            <div className="h-full min-h-[500px]">
              <img
                src={prizes[0].img}
                alt={prizes[0].title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[2000ms]"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/10 to-transparent" />
            
            <div className="absolute top-6 left-6">
              <span className="bg-primary text-white text-[10px] font-black px-4 py-2 rounded-full shadow-lg tracking-widest uppercase">
                {prizes[0].tag}
              </span>
            </div>
            
            <div className="absolute bottom-10 left-10 right-10">
              <p className="text-white/60 text-[10px] font-black uppercase tracking-[0.3em] mb-2">Luxus & Exklusivität</p>
              <h3 className="text-white font-playfair font-black text-3xl mb-1">{prizes[0].title}</h3>
              <p className="text-primary-light text-4xl font-black mb-6">{prizes[0].value}</p>
              
              <div className="flex flex-wrap gap-2">
                {prizes[0].features.map((f) => (
                  <span key={f} className="bg-white/10 backdrop-blur-md border border-white/10 text-white text-[9px] font-bold px-3 py-1.5 rounded-full whitespace-nowrap">
                    {f}
                  </span>
                ))}
              </div>
            </div>
          </Link>

          {/* Secondary prizes */}
          {prizes.slice(1).map((prize) => (
            <Link
              key={prize.id}
              to={`/lot/${prize.id}`}
              className="group relative rounded-[2rem] overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-1 bg-white border border-slate-100 block"
            >
              <div className="h-56 relative overflow-hidden">
                <img
                  src={prize.img}
                  alt={prize.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[1500ms]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <span className={`absolute top-4 left-4 ${prize.tagColor} text-white font-black text-[9px] px-3 py-1.5 rounded-full shadow-lg tracking-widest uppercase`}>
                  {prize.tag}
                </span>
              </div>
              <div className="p-8">
                <h3 className="text-slate-900 font-bold text-lg mb-1">{prize.title}</h3>
                <p className="text-primary font-playfair font-black text-2xl mb-4">{prize.value}</p>
                <div className="space-y-2">
                  {prize.features.map(f => (
                    <div key={f} className="flex items-center gap-2 text-[10px] font-bold text-slate-400">
                      <i className="ri-checkbox-circle-fill text-secondary"></i> {f}
                    </div>
                  ))}
                </div>
                
                <div className="mt-6 flex items-center gap-2 text-primary font-bold text-xs group-hover:gap-3 transition-all">
                   Details ansehen <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
